import { Route, Routes } from "react-router-dom";
import { Suspense } from "react";
import Layout from "src/layout";
import Transactions from "src/pages/Transactions/Transactions";
import SplashScreen from "src/components/SplashScreen/SplashScreen";
import Login from "src/pages/Login/Login";
import ProtectedRoutes from "src/router/ProtectedRoutes";
import ProgramPage from "src/pages/Program/Program";
import ProductsPage from "src/pages/Products";
import ConfigurationsPage from "src/pages/Configurations";
import SyncPage from "src/pages/Sync";
import { useSelector } from "react-redux";
import { getProgram } from "src/store/slices/auth";
import { RootState } from "src/store";
import NotFoundPage from "src/pages/NotFound";
import TagsPage from "src/pages/Tags";
import { useCheckAccess } from "src/HOC/withRBAC";

const featureRoutes = [
  { path: "/", element: <Transactions /> },
  { path: "configurations", element: <ConfigurationsPage /> },
  { path: "sync", element: <SyncPage /> },
  { path: "items", element: <ProductsPage /> },
  { path: "tags", element: <TagsPage /> },
];

export default function AppRoute() {
  const checkAccess = useCheckAccess();
  const state = useSelector((state: RootState) => state);
  const curFeatures = getProgram(state)?.features;

  const curRoutes = featureRoutes
    .filter((route) => curFeatures?.includes(route.path))
    .filter((tab) => {
      if (tab.path === "sync") return checkAccess("sync");
      return true;
    });

  return (
    <Suspense fallback={<SplashScreen isLoading />}>
      <Routes>
        <Route path="/program" element={<ProgramPage />} />
        <Route path="/program/login/:id" element={<Login />} />
        <Route path="/" element={<ProtectedRoutes />}>
          <Route path="/" element={<Layout />}>
            <Route index element={<Transactions />} />
            {curRoutes?.map((feature) => (
              <Route
                key={feature.path}
                path={`/${feature.path}`}
                element={feature.element}
              />
            ))}
            <Route index element={<Transactions />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Route>
      </Routes>
    </Suspense>
  );
}
